import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'categories',
            name: 'category',
            class: 'Modules\\Category\\Entities\\Category',

            categorizableTypes: [],
            loadingCategorizableTypes: false,

            staticAllCategorizables: [],
            loadingStaticAllCategorizables: false,

            allCategorizables: [],
            loadingAllCategorizables: false,

            tree: [],
            loadingTree: false,

            // dataTable: {
            //     headerTopComponents: [
            //         {
            //             component: 'categories-tree-button'
            //         }
            //     ]
            // }
        }
    },

    methods: {
        loadCategorizableTypes() {
            this.$set(this, 'loadingCategorizableTypes', true)

            axios({
                method: 'get',
                url: route('api.categories.categorizables')
            })
            .then(response => {
                if(response.data.success) {
                    this.$set(this, 'categorizableTypes', response.data.data)

                    return response.data.data
                } else {
                    this.$alert(response.data.message, 'Error!', 'error')
                }
            })
            .catch(error => this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error'))
            .finally(() => this.$set(this, 'loadingCategorizableTypes', false))
        },

        loadStaticAllCategorizables() {
            this.$set(this, 'loadingStaticAllCategorizables', true)

            return axios({
                method: 'get',
                url: route('api.categories.staticAllCategorizables')
            })
            .then(response => {
                if(response.data.success) {
                    this.$set(this, 'staticAllCategorizables', response.data.data)

                    return response.data.data
                } else {
                    this.$alert(response.data.message, 'Error!', 'error')
                }
            })
            .catch(error => this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error'))
            .finally(() => this.$set(this, 'loadingStaticAllCategorizables', false))
        },

        loadAllCategorizables(resource) {
            this.$set(this, 'loadingAllCategorizables', true)

            return axios({
                method: 'get',
                url: route('api.categories.allCategorizables', resource)
            })
            .then(response => {
                if(response.data.success) {
                    this.$set(this, 'allCategorizables', response.data.data)

                    return response.data.data
                } else {
                    this.$alert(response.data.message, 'Error!', 'error')
                }
            })
            .catch(error => this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error'))
            .finally(() => this.$set(this, 'loadingAllCategorizables', false))
        },

        loadTree() {
            this.$set(this, 'loadingTree', true)

            return axios({
                method: 'get',
                url: route('api.categories.tree')
            })
            .then(response => {
                if(response.data.success) {
                    this.$set(this, 'tree', response.data.data)

                    return response.data.data
                } else {
                    this.$alert(response.data.message, 'Error!', 'error')
                }
            })
            .catch(error => this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error'))
            .finally(() => this.$set(this, 'loadingTree', false))
        },

        flattenTree(tree = null, flattened = []) {
            tree = tree
                ? tree
                : this.tree

            for (const category of tree) {
                flattened.push(category)
                
                if (category.children) {
                    this.flattenTree(
                        category.children,
                        flattened
                    )
                }
            }
            
            return flattened
        },

        loadLight(type) {
            const placement = `${type}_light`
            const light = _.get(this.placements, placement)

            return light
                ? light
                : this.loadAll({
                    placement: placement,
                    scopes: {
                        whereType: type,
                        lightScope: true,
                        array: [
                            'orderBy',
                            'categories.name->es',
                            'asc'
                        ]
                    }
                })
        },

        loadCustomScope(custom_scope) {
            const data = _.get(this.placements, custom_scope)

            let scopes = {}
            scopes[custom_scope] = true

            return data
                ? data
                : this.loadAll({
                    placement: custom_scope,
                    scopes: scopes
                })
        }
    }
}